import common = require("../../../common");
import { IHotEditableFieldComponent } from '../../../common';
import HotEditableButtonComponent = require("./HotEditableButtonComponent");

class HotEditableFormAction {
    parent: common.IHotEditableFormParentVue;
    validationErrorMessage = [] as string[];

    private _formMode?: common.HotEditableFormModes;
    private _changedField?: IHotEditableFieldComponent;
    private _clickedButton?: HotEditableButtonComponent;
    private _clickedButtonContext?: common.IButtonClickContext;
    private _actionType?: common.HotEditableActionTypes;
    private _actionValue?: string;
    private _errors = [] as common.IError[];

    constructor(parent: common.IHotEditableFormParentVue) {
        this.parent = parent;
        this._formMode = parent.formMode || common.HotEditableFormModes.original;
        this._actionType = common.HotEditableActionTypes.unknown;
        this._actionValue = null;
    }

    hasErrors() {
        return !!this._errors.length;
    }

    addError(error: common.IError) {
        if (error)
            this._errors.push(error)
        return this;
    }

    addErrors(errors?: common.IError[]) {
        if (!errors)
            return;

        for (let i = 0; i < errors.length; i++)
            this.addError(errors[i]);

        return this;
    }

    clearErrors() {
        this._errors = [];
    }

    getErrors() {
        return this._errors;
    }

    getFirstError() {
        return this._errors && this._errors.length ? this._errors[0] : null;
    }

    // L'etat d'origine du formulaire 
    isOriginalFormMode() {
        return !this._formMode || this._formMode === common.HotEditableFormModes.original;
    }

    /** Mode HotEdit dans lequel les changements s'effectue en cliquant et en editant directement (live) la valeur. */
    isEditionFormMode() {
        return this._formMode && this._formMode === common.HotEditableFormModes.edition;
    }

    isButtonClick() {
        return !!this._clickedButton;
    }

    isFieldChanged() {
        return !!this._changedField;
    }

    setActionType(actionType: common.HotEditableActionTypes) {
        this._actionType = actionType || common.HotEditableActionTypes.unknown;
        return this;
    }

    setActionValue(actionValue?: string) {
        this._actionValue = actionValue || null;
        return this;
    }
    setChangedField(field: IHotEditableFieldComponent) {
        this._changedField = field;
        this._actionType = common.HotEditableActionTypes.unknown;
        return this;
    }

    setClickedButton(button: HotEditableButtonComponent, context: common.IButtonClickContext) {
        this._clickedButton = button ?? null;
        this._clickedButtonContext = context ?? null;

        if (!button)
            return;

        // Action Type
        if (button.actionType)
            this._actionType = common.HotEditableActionTypes[button.actionType];

        if (this._actionType === common.HotEditableActionTypes.unknown) {
            if (button.buttonType === common.HotEditableButtonTypes.cancel)
                this._actionType = common.HotEditableActionTypes.cancel;
            else if (button.buttonType === common.HotEditableButtonTypes.create)
                this._actionType = common.HotEditableActionTypes.create;
            else if (button.buttonType === common.HotEditableButtonTypes.update)
                this._actionType = common.HotEditableActionTypes.update;
            else if (button.buttonType === common.HotEditableButtonTypes.delete)
                this._actionType = common.HotEditableActionTypes.delete;
            else if (button.buttonType === common.HotEditableButtonTypes.apply)
                this._actionType = common.HotEditableActionTypes.apply;
            else if (button.buttonType === common.HotEditableButtonTypes.clear)
                this._actionType = common.HotEditableActionTypes.reset;
            else
                this._actionType = common.HotEditableActionTypes.unknown;
        }

        // Action Value
        if (button.actionValue)
            this._actionValue = button.actionValue;
        return this;
    }

    getFieldTextualValue() {

        return this.isFieldChanged() ? this._changedField.getTextualValue() : null;
    }

    getFieldDisplayName() {
        return this.isFieldChanged() ? (this._changedField.displayName || '') : null
    }

    getFieldName() {
        return this.isFieldChanged() ? this._changedField.elementName : null;
    }

    getFieldOrButtonName() {
        return this.getFieldName() || this.getButtonName();
    }

    getFieldType() {
        return this.isFieldChanged() ? this._changedField.fieldType : null;
    }

    getId() {
        return this.isFieldChanged() ? this._changedField.idElement : (this.isButtonClick() ? this._clickedButton.idElement : null);
    }

    getButtonType() {
        return this.isButtonClick() ? this._clickedButton.buttonType : null;
    }

    getButtonName() {
        return this.isButtonClick() ? this._clickedButton.elementName : null;
    }

    getButtonClickContext() { 
        const c = this._clickedButtonContext ?? {} as common.IButtonClickContext;
        if (this.isButtonClick())
            c.name = this.getButtonName();
        return c;
    }

    getActionType() {
        return this._actionType || common.HotEditableActionTypes.unknown;
    }
    getActionValue() {
        return this._actionValue || null;
    }
}
export = HotEditableFormAction;